<template>
  <v-sheet>
    <v-form ref="frmTimeCheck">
      <v-row v-if="isOptionHideSection" no-gutters>
          <v-col 
                cols="12" md="3" sm="5" 
                class="max-width-hide-section ml-auto mt-1"
          >
                <v-switch compact dense
                  hide-details="auto"
                  color="#F00"
                  class="includeFlagSwitch pb-3 px-6"
                  :input-value="SelectedSection.isHidden"
                  :true-value="1"
                  :false-value="0"
                  :label="$t('page.sectionEditor.hide_section')"
                  @change="updateField('isHidden', $event)"
                ></v-switch>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-card-title class="no-color">
                <v-text-field
                    hide-details="auto"
                    :label="$t('page.sectionEditor.section_name')"
                    outlined
                    dense
                    name="sectionName"
                    v-model="SelectedSection.sectionName"
                    @input="updateField('sectionName', SelectedSection.sectionName)"
                    :rules="[ (v) => $inputRules({ value: v }, 'filled') || $t('page.sectionEditor.errors.section-name-required') ]"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-switch
                  compact
                  dense
                  hide-details="auto"
                  color="#F00"
                  class="includeFlagSwitch pb-3 pr-6"
                  name="includeFlag"
                  v-model="SelectedSection.includeFlag"
                  @change="updateField('includeFlag', SelectedSection.includeFlag)"
                  :true-value="0"
                  :false-value="1"
                  :label="$t('page.sectionEditor.throwwholesection')"
                ></v-switch>
                <v-btn @click="cloneSection" small class="mr-5 mt-1">
                  <v-icon left dark>fas fa-clone</v-icon>
                  {{ $t('page.sectionEditor.clone_section', 1) }}
                </v-btn>
                <v-btn @click="deleteSectionConfirm" small class="mt-1">
                  <v-icon left dark>fas fa-trash</v-icon>
                  {{ $t('page.sectionEditor.delete_section', 1) }}
                </v-btn>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-expansion-panels focusable hover multiple v-model="expandedPanels">

            <v-expansion-panel multiple>
              <v-expansion-panel-header>
                <span>{{ $t('page.sectionEditor.check') }} </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <Check 
                  ref="check"
                  :Section="SelectedSection" 
                />
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>{{ $t('page.sectionEditor.thrown_classes') }} </v-expansion-panel-header>
              <v-expansion-panel-content>
                <SectionClasses 
                  :Section="SelectedSection" 
                />
              </v-expansion-panel-content>
            </v-expansion-panel>

          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-form>

    <SGSNotificationConfirm v-if="dialog" :notificationMessage="$t('page.sectionEditor.delete-confirmation-message')" @cancel="dialog=false;" @agree="deleteSection()" type='warning'/>
    <SGSNotificationAlert v-if="errorDialog" :notificationMessage="$t(`page.sectionEditor.${errorDialogMessage}`)" @cancel="errorDialog=false;" type='error'/>

  </v-sheet>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import Check from "@/components/section-editor/time-check/Check.vue";
import SectionClasses from "@/components/section-editor/SectionClasses.vue";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";

export default {
  mixins: [apiCalls], //for api redundant operations
  props: ["SelectedSection"],
  components: {
    Check, 
    SectionClasses,
    SGSNotificationConfirm,
    SGSNotificationAlert
  },
  data() {
    return {
      sectionDetailsAPIUrl: '/api/v1/promoter/section',
      dialog: false,
      errorDialog: false,
      errorDialogMessage: '',
      VUE_APP_HEADER_COLOR: process.env.VUE_APP_HEADER_COLOR,
      expandedPanels: []
    };
  },  
  mounted() {},
  methods: {
    updateField(field, value) {
      let formData = {
        sectionId: this.SelectedSection.id,
        raceId: this.SelectedSection.raceId,
        field,
        value
      };
      this.$store.dispatch('addSectionTimeCheckUpdateAction', formData);
    },
    deleteSectionConfirm(){
      this.dialog = true
    },
    deleteSection: async function() {
      this.dialog = false
      let formData = new FormData();
      formData.append("raceSectionId", this.SelectedSection.id);
      formData.append("raceId", this.SelectedSection.raceId);

      const data = await this.api('delete', '/api/v1/promoter/section', formData);
      
      if(typeof data == 'undefined' || (data && typeof data.error == 'undefined')){
        const response = data;
        if (/^-?\d+$/.test(response)) {
          this.$store.dispatch('getSectionsAction',this.SelectedSection.raceId);
        } else {
          if(response){
            this.errorDialogMessage = response;
            this.errorDialog = true;
          }
        }
      }else{
        this.errorDialogMessage = data
        this.errorDialog = true
      }

    },
    cloneSection: async function() {
      let formData = new FormData();
      formData.append("raceSectionId", this.SelectedSection.id);
      formData.append("raceId", this.SelectedSection.raceId);

      const response = await this.api('post', '/api/v1/promoter/section', formData);
      if (response) {
        this.$store.dispatch('getSectionsAction',this.SelectedSection.raceId);
      }
    },
  },
  computed: {
    isOptionHideSection() {
      return this.Race?.mode == 10 || this.Race?.mode == 11;
    },
    Race() {
      return this.$store.getters.getRaceSections;
    },
  }
};
</script>


<style scoped>
</style>